<app-card>
  <div *ngIf="{ questions: questions$ | async } as data" app-card-content class="h-auto">
    <ng-container *ngIf="application.shuffle">
      <app-form-field class="w-full" [required]="false">
        <ng-select
          app-select
          [formControl]="randModeCtrl"
          [clearable]="false"
          [searchable]="false"
          [placeholder]="'gestor-avaliacoes.selecione-modelo' | translate"
        >
          <ng-option [value]="1">{{ 'gestor-avaliacoes.modelo' | translate }} 1</ng-option>
          <ng-option [value]="2">{{ 'gestor-avaliacoes.modelo' | translate }} 2</ng-option>
          <ng-option [value]="3">{{ 'gestor-avaliacoes.modelo' | translate }} 3</ng-option>
          <ng-option [value]="4">{{ 'gestor-avaliacoes.modelo' | translate }} 4</ng-option>
          <ng-option *ngIf="!isAnswerPrinted && !!randModeCtrl.value" [value]="randModeCtrl.value"
            >{{ 'gestor-avaliacoes.modelo' | translate }} {{ randModeCtrl.value }}</ng-option
          >
        </ng-select>
      </app-form-field>
    </ng-container>

    <button
      app-flat-button
      *ngIf="(!application.shuffle || !!randModeCtrl.value) && isAnswerPrinted"
      (click)="onSetAllBlank()"
      class="mb-5 flex h-9 w-full justify-center gap-3 bg-base-status-info"
    >
      <ng-container *ngIf="isStudentLoading; else iconAllblank">
        <app-skeleton class="flex !h-4 !w-4" [showLabel]="false"></app-skeleton>
      </ng-container>
      <ng-template #iconAllblank>
        <svg-icon
          class="group-hover:text-theme-contraste mr-2 w-5 text-white"
          src="assets/icons/icon-comments-disable.svg"
        ></svg-icon>
      </ng-template>
      <span class="text-white group-hover:text-theme-contrast md:inline-block" translate>
        gestor-avaliacoes.todas-em-branco
      </span>
    </button>

    <ng-container *ngIf="canShowQuestions || !data.questions?.length; else emptyQuestionsTemplate">
      <div
        *ngFor="let question of data.questions; trackBy: trackByUuid; let index = index"
        (click)="onSelectQuestion(question)"
        [id]="'question_' + question.uuid"
        class="pb-5"
      >
        <app-card
          *ngIf="{ value: onGetAnswer(question.uuid) } as answer"
          class="grid !flex-row items-center rounded-xl p-4 !shadow-black/25 hover:bg-base-whisper-300 md:flex md:w-full xl:w-full"
          [ngClass]="{ 'shadow-inner !shadow-black/40': question.selected }"
        >
          <div class="grid w-full gap-4">
            <div class="flex justify-between">
              <div class="flex w-full">
                <span class="flex w-full items-center gap-2 text-md font-semibold">
                  {{ 'gestor-avaliacoes.questao' | translate }} {{ index + 1 }}
                  <div *ngIf="question.loading" class="ml-2 flex h-6 w-6 items-center justify-center">
                    <app-skeleton class="flex h-4 w-4" [showLabel]="false"></app-skeleton>
                  </div>
                  <svg-icon
                    *ngIf="answer.value?.has_problem"
                    class="mr-2 flex h-4 text-danger"
                    src="assets/icons/icon-alert-fill.svg"
                  ></svg-icon>
                </span>
              </div>

              <div class="flex w-full justify-end gap-2 pt-5 md:pt-0">
                <ng-container [ngSwitch]="question.tipo">
                  <ng-container *ngSwitchCase="assessmentQuestionTypeEnum.Objetiva">
                    <div class="flex w-full gap-2 md:justify-end">
                      <ng-container
                        *ngFor="let alternative of question.alternativas; let i = index; trackBy: trackByUuid"
                      >
                        <span
                          *ngIf="onGetAlternativeClass(question, alternative, answer.value) as class"
                          (click)="onSetAlternative(question.uuid, alternative.uuid, answer.value)"
                          class="flex w-16 cursor-pointer items-center justify-center rounded-lg border bg-white px-2 py-0 text-[1.2rem] shadow-sm shadow-black/40 hover:border-base-mantis-400 hover:text-base-mantis-400"
                          [ngClass]="class"
                        >
                          <ng-container *ngIf="!question?.sociodemografica">
                            <svg-icon
                              *ngIf="!!alternative.alternativa_correta"
                              class="mr-2 flex h-3"
                              src="assets/icons/icon-check.svg"
                            ></svg-icon>
                            <svg-icon
                              *ngIf="
                                alternative.uuid === answer.value?.alternativa?.uuid && !alternative.alternativa_correta
                              "
                              class="mr-2 flex h-3"
                              src="assets/icons/icon-delete.svg"
                            ></svg-icon>
                          </ng-container>

                          {{ onGetLetter(i) }}
                        </span>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="assessmentQuestionTypeEnum.Discursiva">
                    <div class="flex items-center">
                      <ng-container *ngFor="let scale of SCALES">
                        <ng-container *ngIf="onCalculateScaleScore(question.peso, scale.value) as result">
                          <div
                            class="border-l-none flex !items-center border border-gray-200 bg-gray-200 first:rounded-l-lg last:rounded-r-lg"
                          >
                            <button
                              (click)="onSetScore(question.uuid, result?.score, answer.value)"
                              [ngClass]="{
                                'shadow-inner shadow-black/40': result.score === answer.value?.nota
                              }"
                              [id]="'btn_' + scale.shortcut"
                              class="flex p-1 px-3 transition-all duration-300 hover:bg-white/80 md:px-5"
                            >
                              <span
                                *ngIf="application.assessment.weight_type === assessmentWeightType.Peso; else percent"
                              >
                                {{ result.score | currency : '' : '' : '1.2-2' }}
                              </span>
                              <ng-template #percent>
                                {{ scale.value | percent }}
                              </ng-template>
                            </button>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>

                <app-badge-annuled-question
                  *ngIf="!!answer.value?.anulado; else optionsTemplate"
                  [cancelAnnulment]="true"
                  (updateQuestion)="onCancelAnull($event, question.uuid)"
                  [applicationUuid]="application.uuid"
                  [questionUuid]="question.uuid"
                  [tentativaUuid]="studentAttemptUuid"
                ></app-badge-annuled-question>
                <ng-template #optionsTemplate>
                  <button
                    #popoverTop
                    app-outline-button
                    type="button"
                    class="top-[-1.6rem] !border-none bg-black/5 p-2 text-black md:top-[0rem] hover:[&:not([disabled])]:bg-black hover:[&:not([disabled])]:text-theme-contrast"
                  >
                    <svg-icon
                      (click)="onOpenPopoverOptions(popoverTop, question)"
                      class="flex h-5"
                      src="assets/icons/icon-three-dots.svg"
                    ></svg-icon>
                  </button>
                </ng-template>
              </div>
            </div>
            <div *ngIf="answer.value?.uuid && !question.sociodemografica" class="flex justify-between border-t pt-4">
              <p translate>
                {{ 'gestor-avaliacoes.nota' | translate }}:
                <span
                  *ngIf="!isNil(answer.value?.nota); else emptyTemplate"
                  [ngClass]="{ 'line-through': !!answer.value?.anulado }"
                  >{{ answer.value?.nota | currency : '' : '' : '1.2-2' }}</span
                >/{{ question.peso | currency : '' : '' : '1.2-2' }}
              </p>
              <p *ngIf="onGetAnswerAuditClass(answer.value) as class" class="mb-0 text-sm" [ngClass]="class">
                <ng-container *ngIf="!!answer.value?.alterado_por; else auditTemplate">
                  {{ 'gestor-avaliacoes.auditado-por' | translate }}
                  {{ answer.value?.alterado_por?.nome }}:
                  {{ answer.value?.updated_at | date : 'dd/MM HH:mm' }}
                </ng-container>
                <ng-template #auditTemplate>
                  {{ 'gestor-avaliacoes.auditado-em' | translate }}:
                  {{ answer.value?.updated_at | date : 'dd/MM HH:mm' }}
                </ng-template>
              </p>
            </div>
          </div>
        </app-card>
      </div>
    </ng-container>

    <ng-template #emptyQuestionsTemplate>
      <div class="grid h-[200px] gap-4">
        <app-skeleton *ngIf="false; else jumbotron"></app-skeleton>
        <ng-template #jumbotron>
          <app-jumbotron [showIcon]="false" translate>
            <svg-icon class="mb-5 w-10 text-gray-300" src="assets/icons/icon-info-rounded.svg"> </svg-icon>
            <ng-container *ngIf="!data.questions?.length; else noRandModeTemplate">
              gestor-avaliacoes.selecione-modelo
            </ng-container>
            <ng-template #noRandModeTemplate> gestor-avaliacoes.selecione-modelo </ng-template>
          </app-jumbotron>
        </ng-template>
      </div>
    </ng-template>
  </div>
</app-card>

<ng-template #emptyTemplate>-</ng-template>
